module.exports = __webpack_public_path__ + "static/media/davi.ed78d9c9.png";